/*
 * Akciós beúszó doboz – Pödör
 * Blokk: application/blocks/akcio_beuszo (gyűjtőalbum: akcio_beuszo)
 *
 * Állapot a böngészőben (localStorage 'akcioBeuszo'):
 *   { k: kampányazonosító, s: 'open' | 'tab' | 'hidden', n: hány munkamenetben nyílt ki magától }
 * Ha a kampányazonosító változik (új/átírt akció), az állapot nullázódik.
 */

const KULCS = 'akcioBeuszo';
const MUNKAMENET_KULCS = 'akcioBeuszoMunkamenet';
const KESLELTETES_MS = 3000;        // első oldalon ennyi után úszik be
const KESLELTETES_KESOBB_MS = 400;  // munkameneten belüli további oldalakon
const MAX_NYITOTT_MUNKAMENET = 3;   // ennyi munkamenetben nyílik ki magától, utána csak fül
const SUTIBANNER = '.super-popup.gdpr';

function olvas(tar, kulcs) {
    try { return window[tar].getItem(kulcs); } catch (e) { return null; }
}

function ir(tar, kulcs, ertek) {
    try { window[tar].setItem(kulcs, ertek); } catch (e) { /* privát mód stb. */ }
}

class AkcioBeuszo {
    constructor() {
        const elemek = document.querySelectorAll('.akcio-beuszo[data-kampany]');
        if (!elemek.length) {
            return;
        }
        // egyszerre csak egy akciós doboz lehet az oldalon
        for (let i = 1; i < elemek.length; i++) {
            elemek[i].remove();
        }
        this.init(elemek[0]);
    }

    init(el) {
        this.el = el;
        this.panel = el.querySelector('.ab-panel');
        this.tab = el.querySelector('.ab-tab');
        this.tabNyit = el.querySelector('.ab-tab-open');

        const kampany = el.getAttribute('data-kampany');
        this.st = this.allapotBetolt(kampany);

        if (this.st.s === 'hidden') {
            el.remove();
            return;
        }

        this.elsoOldal = olvas('sessionStorage', MUNKAMENET_KULCS) !== kampany;
        if (this.elsoOldal) {
            if (this.st.s === 'open') {
                this.st.n += 1;
                if (this.st.n > MAX_NYITOTT_MUNKAMENET) {
                    this.st.s = 'tab';
                }
            }
            this.allapotMent();
            ir('sessionStorage', MUNKAMENET_KULCS, kampany);
        }

        this.esemenyek();
        setTimeout(() => this.varSutibannerre(), this.elsoOldal ? KESLELTETES_MS : KESLELTETES_KESOBB_MS);
    }

    allapotBetolt(kampany) {
        let st = null;
        try { st = JSON.parse(olvas('localStorage', KULCS) || 'null'); } catch (e) { st = null; }
        if (!st || st.k !== kampany) {
            st = { k: kampany, s: 'open', n: 0 };
        }
        return st;
    }

    allapotMent() {
        ir('localStorage', KULCS, JSON.stringify(this.st));
    }

    esemenyek() {
        const bezar = () => {
            this.st.s = 'tab';
            this.allapotMent();
            this.mod('tab');
        };

        this.el.querySelector('.ab-close').addEventListener('click', bezar);

        // csak most nyitja ki, a tárolt állapot fül marad
        this.tabNyit.addEventListener('click', () => this.mod('open'));

        this.el.querySelector('.ab-tab-close').addEventListener('click', () => {
            this.st.s = 'hidden';
            this.allapotMent();
            this.el.classList.remove('is-in');
            document.body.classList.remove('ab-van');
            setTimeout(() => this.el.remove(), 300);
        });

        // látta és rákattintott → többé nem nyílik ki magától
        const gomb = this.el.querySelector('.ab-gomb');
        if (gomb) {
            gomb.addEventListener('click', () => {
                this.st.s = 'tab';
                this.allapotMent();
            });
        }

        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape' && this.el.classList.contains('is-open')) {
                bezar();
            }
        });
    }

    varSutibannerre() {
        const banner = document.querySelector(SUTIBANNER);
        if (banner && banner.offsetParent !== null) {
            setTimeout(() => this.varSutibannerre(), 1000);
        } else {
            this.megjelenit();
        }
    }

    megjelenit() {
        if (window.newsletterPopupActive || olvas('sessionStorage', 'newsletter-popup-active')) {
            this.st.s = 'tab';
        }
        const el = this.el;
        el.hidden = false;
        document.body.classList.add('ab-van');
        this.mod(this.st.s === 'tab' ? 'tab' : 'open');
        if (!this.elsoOldal) {
            el.classList.add('no-anim');
        }
        // a beúszó animációhoz egy frame késleltetés kell
        requestAnimationFrame(() => requestAnimationFrame(() => el.classList.add('is-in')));
        if (window.ResizeObserver) {
            new ResizeObserver(() => this.eltolasFrissit()).observe(el);
        }
    }

    mod(uj) {
        this.el.classList.remove('is-open', 'is-tab');
        this.el.classList.add(uj === 'open' ? 'is-open' : 'is-tab');
        this.tabNyit.setAttribute('aria-expanded', uj === 'open' ? 'true' : 'false');
        this.eltolasFrissit();
    }

    // a "vissza a tetejére" gomb ennyivel kerüljön feljebb
    eltolasFrissit() {
        const r = this.el.classList.contains('is-open') ? this.panel : this.tab;
        const m = r ? r.getBoundingClientRect().height : 0;
        document.documentElement.style.setProperty('--ab-eltolas', Math.round(m) + 'px');
    }
}

export default AkcioBeuszo;
